<template>
  <span class="pure-form-message-inline" >
    <a @click.prevent="$emit('click')" >
      <img
        src="../../../public/img/icons/eye.svg"
        width="30"
        height="30"
        v-on:click="toggleEye()"
        v-if="!toggle"
      />
      
      <img
        src="../../../public/img/icons/Open_eye.svg"
        width="30"
        height="30"
        v-on:click="toggleEye()"
        v-if="toggle"
      />
    </a>
  </span>
</template>
<script>
export default {
  data() {
    return {
      toggle: false,
    };
  },
  methods: {
    toggleEye() {
      if (this.toggle === false) {
        this.toggle = true;
      }
      else if(this.toggle === true) {
        this.toggle = false;
      }
    },
    
  },

  mounted() {
    this.toggle = false;
  },
};
</script>

<style lang="less" scoped>
a {
  img{
        margin-top: 10px;
  }
  display: block;
  height: 55px;
  widows: 55px;
  z-index: 9000;
  &:hover {
    cursor: pointer;
  }
}

a:disabled{
  cursor: not-allowed;
  background-color: black;
}
</style>